import script from "./LeadCaptureSection.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadCaptureSection.vue?vue&type=script&setup=true&lang=js"

import "./LeadCaptureSection.vue?vue&type=style&index=0&id=2cbf0e6e&scoped=true&lang=css"

import exportComponent from "/Users/yousefgadban/Developer/applates/applatesLandingVue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cbf0e6e"]])

export default __exports__